import React, { useMemo, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CategoryFilter } from './components/CategoryFilter';
import { FeaturedStartups } from './components/FeaturedStartups';
import { StartupGrid } from './components/StartupGrid';
import { StatsStrip } from './components/StatsStrip';
import { SubmitCTA } from './components/SubmitCTA';
import { Footer } from './components/Footer';
import { STARTUPS, Category } from './data/startups';
export function App() {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState<Category>('All');
  const filteredStartups = useMemo(() => {
    return STARTUPS.filter(startup => {
      const matchesCategory = activeCategory === 'All' || startup.category === activeCategory;
      const searchLower = searchQuery.toLowerCase();
      const matchesSearch = startup.name.toLowerCase().includes(searchLower) || startup.tagline.toLowerCase().includes(searchLower) || startup.category.toLowerCase().includes(searchLower);
      return matchesCategory && matchesSearch;
    });
  }, [searchQuery, activeCategory]);
  return <div className="min-h-screen bg-white text-neutral-900 selection:bg-[#FF6B1A]/20 selection:text-neutral-900" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero searchQuery={searchQuery} setSearchQuery={setSearchQuery} data-id="element-3" />

        <CategoryFilter activeCategory={activeCategory} setActiveCategory={setActiveCategory} data-id="element-4" />

        {/* Only show featured if no search/filter is active */}
        {searchQuery === '' && activeCategory === 'All' && <FeaturedStartups data-id="element-5" />}

        <StartupGrid startups={filteredStartups} data-id="element-6" />

        <StatsStrip data-id="element-7" />

        <SubmitCTA data-id="element-8" />
      </main>

      <Footer data-id="element-9" />
    </div>;
}